export default __webpack_public_path__ + "static/media/unl_logo.bb599b0f.jpg";